import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { IHeaderConfigOptionsAI, IMessageAnswerChoicesOpenAI, IMessageAnswerOpenAI, IMessageOpenAI, InputMessageRequest, IOptionsAI, OutputMessageResponse } from "@core/models";
import { environment } from "environments/environment";


@Injectable({ providedIn: "root" })
export class OpenAIService {
  private sessionId: string | null = null;

  private currentConfigSubject: BehaviorSubject<IOptionsAI>;
  private currentSourceSubject: BehaviorSubject<string>;
  private configSelectedSubject: BehaviorSubject<IOptionsAI>;

  /**
   * Constructor
   * @param {HttpClient} _http
  */
  constructor(private _http: HttpClient) {
    this.currentConfigSubject = new BehaviorSubject(null);
    this.currentSourceSubject = new BehaviorSubject(null);
    this.configSelectedSubject = new BehaviorSubject(null);
  }

  // getter: currentConfigValue
  public get currentConfigValue(): IOptionsAI {
    return this.currentConfigSubject.value;
  }

  // getter: event current config value changed
  public get onCurrentConfigChanged(): Observable<IOptionsAI> {
    return this.currentConfigSubject.asObservable();
  }

  // getter: configSelectedValue
  public get configSelectedValue(): IOptionsAI {
    return this.configSelectedSubject.value;
  }

  // getter: event config selected value changed
  public get onConfigSelectedChanged(): Observable<IOptionsAI> {
    return this.configSelectedSubject.asObservable();
  }

  // getter: currentSourceValue
  public get currentSourceValue(): string {
    return this.currentSourceSubject.value;
  }

  // getter: event current source value changed
  public get onCurrentSourceChanged(): Observable<string> {
    return this.currentSourceSubject.asObservable();
  }

  /**
   * Registra la configuración inicial de bix
   * @param {IOptionsAI} config Registra la configuración
   */
  register(config: IOptionsAI): void {
    this.currentConfigSubject.next(config);
  }

  /**
   * Registra la fuente a utilizar para bix
   * @param {string} source Registra la fuente a utilizar
   */
  registerSource(source: string): void {
    this.currentSourceSubject.next(source);
    sessionStorage.setItem("chat-source", source);
  }

  /**
   * Registra la configuración seleccionada
   * @param {IOptionsAI} config Registra la configuración seleccionada 
   */
  registerConfigSelected(config: IOptionsAI): void {
    this.configSelectedSubject.next(config);
  }

  /**
   * Función para enviar consultas al modelo AI
   * @param {InputMessageRequest[]} messages Indica el cuerpo del mensaje para hacer una petición a open ai
   * @returns {IMessageAnswerOpenAI} Devuelve un mensaje con la respuesta del modelo AI
   */
  sendMessage(messages: InputMessageRequest[], region: string): Promise<OutputMessageResponse> {

    //filtering error messages
    messages = messages.filter(msj => msj.role != "error");

   // this.configSelectedValue.sources[0].content.messages= messages;

    return this._http.post<OutputMessageResponse>(`${environment.azureApiUrl}/api/v2/chat-openai`, messages).toPromise();

  }

  runCosmosIndexer(indexerName: string) {
    return this._http.post<any>(`${environment.azureApiUrl}/api/azure-search/indexers/${indexerName}`, "").toPromise();
  }


}
